const normalizeMessage = (value) => String(value || "").replace(/\s+/g, " ").trim();

export const getFoodItemErrorMessage = (rawError, fallbackMessage) => {
  if (!rawError) return fallbackMessage;

  let parsed;
  try {
    parsed = JSON.parse(rawError);
  } catch {
    parsed = null;
  }

  const validationEntries = parsed?.errors ? Object.entries(parsed.errors) : [];
  if (validationEntries.some(([field]) => field.toLowerCase().includes("taxcategoryid"))) {
    return "Please select a valid tax category.";
  }

  const validationMessage = validationEntries
    .filter(([field]) => !/^(menu|menudto)$/i.test(field))
    .flatMap(([, messages]) => Array.isArray(messages) ? messages : [messages])
    .map(normalizeMessage)
    .find(Boolean);

  const candidate = validationMessage || parsed?.message || parsed?.title || rawError;
  const normalized = normalizeMessage(candidate);
  const looksTechnical = /exception|stack trace|sql|database|innerexception|system\.|microsoft\.|could not be converted|byteposition|line(number)?\s*:|path\s*:| at [a-z0-9_.]+\(/i.test(normalized);
  const isGenericValidationTitle = /^one or more validation errors occurred\.?$/i.test(normalized);

  if (!normalized || looksTechnical || isGenericValidationTitle || normalized.length > 180) {
    return fallbackMessage;
  }
  return normalized;
};
